import { subDays } from 'date-fns'

import { hotelTapeChartPath } from '@new/domains/hotelTapeChart/config/contants'

export const DATE_BORDER_WIDTH = 1

/**
 * @deprecated This const should not be used directly. Use firstColumnStore instead
 */
export const FIRST_COLUMN_WIDTH = {
  DESKTOP: 310,
  MOBILE: 240,
  MOBILE_COLLAPSED: 90,
}

/**
 * @deprecated This const should not be used directly. Use firstColumnStore instead
 */
export const FIRST_COLUMN_LEFT_PADDING = {
  DESKTOP: 30,
  MOBILE: 16,
  MOBILE_COLLAPSED: 10,
}

export const EXTENDED_COLUMN_MIN_WIDTH = 38

/**
 * @deprecated This const should not be used directly. Use extendedColumnWidth from store instead
 */
export const EXTENDED_COLUMN_WIDTH = {
  DESKTOP: EXTENDED_COLUMN_MIN_WIDTH,
  MOBILE: 0,
  MOBILE_COLLAPSED: 0,
}

export const DAY_COLUMN_WIDTH = {
  DESKTOP: 38,
  DESKTOP_MAXIMISED: 54,
  MOBILE: 48,
}

export const TAPE_CHART_ROW_BASE_HEIGHT = {
  DESKTOP: 34,
  DESKTOP_MAXIMISED: 38,
  MOBILE: 36,
}

export const EXTENDED_COLUMN_GAP = 12

export const DEFAULT_VIEW_FROM_DATE = subDays(new Date(), 1)
export const TIME_FRAME_DAYS = 30

export const FILTERS_DATE_FORMAT = 'MMM d, yy'
export const ISO_DATE_FORMAT = 'yyyy-MM-dd'

export const TAPE_CHART_HEADER_ROW_HEIGHT = 30

export const UNKNOWN_GROUP = 'unknown'

export const BOTTOM_BAR_HEIGHT = 60

export const fastTapeChartPaths = [...hotelTapeChartPath]

export const DEFAULT_DATES_FORMATS = {
  monthLabel: 'MMM, yyyy',
  monthDay: 'd',
  weekDay: 'EEE',
}
